<template>
  <div class="community-agent-communities-page">
    <div class="filter-bar">
      <div class="search-box">
        <input
          type="text"
          v-model="filters.community_agent_id"
          placeholder="小区代理ID"
          class="search-input small"
        />
        <input
          type="text"
          v-model="filters.community_id"
          placeholder="小区ID"
          class="search-input small"
        />
        <select v-model="filters.status" class="search-input small">
          <option value="">全部状态</option>
          <option value="1">启用</option>
          <option value="0">禁用</option>
        </select>
        <button @click="search" class="search-btn">搜索</button>
        <button @click="resetFilters" class="search-btn reset">重置</button>
      </div>
      <button @click="openAddModal" class="add-btn">+ 添加代理-小区关联</button>
    </div>

    <div class="table-container">
      <table class="community-agents-table">
        <thead>
          <tr>
            <th>关联ID</th>
            <th>代理ID</th>
            <th>用户ID</th>
            <th>小区ID</th>
            <th>小区名称</th>
            <th>开始日期</th>
            <th>结束日期</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="rel in relations" :key="rel.id">
            <td>{{ rel.id }}</td>
            <td>{{ rel.community_agent_id }}</td>
            <td>{{ rel.communityAgent && rel.communityAgent.user ? rel.communityAgent.user.id : '' }}</td>
            <td>{{ rel.community_id }}</td>
            <td>{{ rel.community ? rel.community.name : '' }}</td>
            <td>{{ formatDate(rel.start_date) }}</td>
            <td>{{ formatDate(rel.end_date) }}</td>
            <td><span :class="'status status-' + (rel.status === 1 ? 1 : 0)">{{ rel.status === 1 ? '启用' : '禁用' }}</span></td>
            <td>
              <button @click="editRelation(rel)" class="action-btn edit">编辑</button>
              <button @click="toggleStatus(rel)" class="action-btn" :class="rel.status === 1 ? 'disable' : 'enable'">
                {{ rel.status === 1 ? '禁用' : '启用' }}
              </button>
              <button @click="deleteRelation(rel)" class="action-btn delete">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button :disabled="currentPage === 1" @click="currentPage--; loadList()" class="page-btn">上一页</button>
      <span class="page-info">第 {{ currentPage }} / {{ totalPages }} 页（共 {{ total }} 条）</span>
      <button :disabled="currentPage === totalPages" @click="currentPage++; loadList()" class="page-btn">下一页</button>
    </div>

    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ editingRelation ? '编辑代理-小区关联' : '添加代理-小区关联' }}</h3>
          <button @click="closeModal" class="close-btn">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>小区代理ID</label>
            <input v-model="form.community_agent_id" type="number" class="form-control" placeholder="请输入小区代理ID" :disabled="!!editingRelation" />
          </div>
          <div class="form-group">
            <label>小区ID</label>
            <input v-model="form.community_id" type="number" class="form-control" placeholder="请输入小区ID" :disabled="!!editingRelation" />
          </div>
          <div class="form-group">
            <label>开始日期</label>
            <input v-model="form.start_date" type="date" class="form-control" />
          </div>
          <div class="form-group">
            <label>结束日期（留空表示长期）</label>
            <input v-model="form.end_date" type="date" class="form-control" />
          </div>
          <div class="form-group">
            <label>状态</label>
            <select v-model.number="form.status" class="form-control">
              <option :value="1">启用</option>
              <option :value="0">禁用</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeModal" class="btn-cancel">取消</button>
          <button @click="saveRelation" class="btn-save">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCommunityAgentCommunityList,
  createCommunityAgentCommunity,
  updateCommunityAgentCommunity,
  deleteCommunityAgentCommunity
} from '@/api/communityAgentCommunities'

export default {
  name: 'CommunityAgentCommunities',
  data() {
    return {
      filters: {
        community_agent_id: '',
        community_id: '',
        status: ''
      },
      currentPage: 1,
      totalPages: 1,
      total: 0,
      relations: [],
      showModal: false,
      editingRelation: null,
      form: {
        community_agent_id: '',
        community_id: '',
        start_date: '',
        end_date: '',
        status: 1
      }
    }
  },
  mounted() {
    // 支持从小区代理列表页带 ?community_agent_id= 跳入，预填筛选
    if (this.$route.query.community_agent_id) {
      this.filters.community_agent_id = this.$route.query.community_agent_id
    }
    this.loadList()
  },
  methods: {
    formatDate(value) {
      if (!value) return '长期'
      return String(value).substring(0, 10)
    },
    buildParams() {
      const params = { page: this.currentPage, pageSize: 20 }
      if (this.filters.community_agent_id.trim() !== '') {
        params.community_agent_id = Number(this.filters.community_agent_id)
      }
      if (this.filters.community_id.trim() !== '') {
        params.community_id = Number(this.filters.community_id)
      }
      if (this.filters.status !== '') {
        params.status = Number(this.filters.status)
      }
      return params
    },
    async loadList() {
      try {
        const response = await getCommunityAgentCommunityList(this.buildParams())
        if (response.code === 0) {
          this.relations = response.data.list || []
          this.total = response.data.total || 0
          this.totalPages = response.data.pageSize
            ? Math.ceil(this.total / response.data.pageSize)
            : 1
        }
      } catch (error) {
      }
    },
    search() {
      this.currentPage = 1
      this.loadList()
    },
    resetFilters() {
      this.filters = { community_agent_id: '', community_id: '', status: '' }
      this.currentPage = 1
      this.loadList()
    },
    openAddModal() {
      this.editingRelation = null
      this.form = {
        community_agent_id: '',
        community_id: '',
        start_date: '',
        end_date: '',
        status: 1
      }
      this.showModal = true
    },
    editRelation(rel) {
      this.editingRelation = rel
      this.form = {
        community_agent_id: rel.community_agent_id,
        community_id: rel.community_id,
        start_date: (rel.start_date || '').substring(0, 10),
        end_date: (rel.end_date || '').substring(0, 10),
        status: rel.status === 1 ? 1 : 0
      }
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
      this.editingRelation = null
      this.form = {
        community_agent_id: '',
        community_id: '',
        start_date: '',
        end_date: '',
        status: 1
      }
    },
    async saveRelation() {
      if (!this.form.community_agent_id || !this.form.community_id) {
        alert('请填写小区代理ID与小区ID')
        return
      }
      const payload = {
        community_agent_id: Number(this.form.community_agent_id),
        community_id: Number(this.form.community_id),
        start_date: this.form.start_date || null,
        end_date: this.form.end_date || null,
        status: this.form.status
      }
      try {
        const response = this.editingRelation
          ? await updateCommunityAgentCommunity(this.editingRelation.id, payload)
          : await createCommunityAgentCommunity(payload)
        if (response && response.code === 0) {
          alert(this.editingRelation ? '更新成功' : '添加成功')
          this.loadList()
          this.closeModal()
        } else {
          alert(response?.message || '操作失败')
        }
      } catch (error) {
        alert('保存失败，请稍后重试')
      }
    },
    toggleStatus(rel) {
      const action = rel.status === 1 ? '禁用' : '启用'
      if (confirm(`确定要${action}该关联（ID: ${rel.id}）吗？`)) {
        rel.status = rel.status === 1 ? 0 : 1
      }
    },
    async deleteRelation(rel) {
      if (!confirm(`确定要删除该关联（ID: ${rel.id}）吗？`)) return
      try {
        const response = await deleteCommunityAgentCommunity(rel.id)
        if (response && response.code === 0) {
          alert('删除成功')
          this.loadList()
        } else {
          alert(response?.message || '删除失败')
        }
      } catch (error) {
        alert('删除失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.community-agent-communities-page {
  padding: 20px;
}

.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.search-box {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.search-input.small {
  width: 130px;
  padding: 9px 12px;
}

.search-btn {
  padding: 10px 20px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.search-btn.reset {
  background: #95a5a6;
}

.add-btn {
  padding: 10px 20px;
  background: #2ecc71;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  overflow: hidden;
}

.community-agents-table {
  width: 100%;
  border-collapse: collapse;
}

.community-agents-table th,
.community-agents-table td {
  padding: 14px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.community-agents-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}

.status {
  border-radius: 20px;
  font-size: 12px;
  padding: 4px 12px;
}

.status-1 { background: #e8f5e9; color: #2ecc71; }
.status-0 { background: #ffebee; color: #e74c3c; }

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 5px;
}

.action-btn.edit { background: #3498db; color: #fff; }
.action-btn.disable { background: #e74c3c; color: #fff; }
.action-btn.enable { background: #2ecc71; color: #fff; }
.action-btn.delete { background: #95a5a6; color: #fff; }

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.page-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 480px;
  max-width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 16px;
}

.close-btn {
  font-size: 24px;
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

.btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}

.btn-save {
  padding: 8px 16px;
  background: #3498db;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
